import { useMemo } from 'react'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useLoadAllItemsQuery } from '@sequencehq/api/utils'

export const useSeatMetrics = () => {
  const getSeatMetricsQuery = useLoadAllItemsQuery(
    dashboard20240730Client.getSeatMetrics,
    {
      limit: 100
    }
  )

  const seatMetrics = useMemo(() => {
    if (getSeatMetricsQuery.data) {
      return getSeatMetricsQuery.data.pages.flatMap(page => page.items)
    }
    return []
  }, [getSeatMetricsQuery.data])

  return {
    metrics: seatMetrics,
    loading: getSeatMetricsQuery.isPending,
    error: getSeatMetricsQuery.isError
  }
}
